const styles = {
  link: {
    color: '#FFFFC0',
    textDecoration: 'none',
  },
};

const InfoContent = () => (
  <>
    <h4>About the Map</h4>
    <p>The public beta version of the Massachusetts Broadband Map was created as part of an ongoing
      program to accurately map fixed broadband availability for each home, business and other serviceable
      locations in the Commonwealth of Massachusetts.
    </p>
    <p>The development of accurate broadband coverage maps is an iterative process and the maps will
      continue to be improved, updated and validated over time. The development and release of the public
      beta version of the Massachusetts Broadband Map is an initial step in this process. The broadband data
      in the map, current as of at least June 30, 2022, was voluntarily shared by service providers and has
      been aggregated to protect sensitive information. The Massachusetts Broadband Institute (MBI) will
      work with service providers on an ongoing basis to review and validate coverage data, including
      identifying areas that require further analysis, and will periodically release updated versions of the
      Massachusetts Broadband Map.
    </p>
    <p>The coverage data is intended to support state broadband investment decisions to close the remaining
      broadband infrastructure gaps in the Commonwealth, provide a means for Massachusetts residents to
      provide feedback on the accuracy of the data, and share data with the FCC to improve the accuracy of
      the National Broadband Map.
    </p>
    <p>The map shows current broadband service coverage throughout the Commonwealth as well as
      individual broadband serviceable locations that are unserved or underserved. Locations that do not have
      access to internet speeds of at least 25 Mbps downstream and 3 Mbps upstream (the current FCC
      definition of broadband) are considered unserved. Locations without access to speeds of at least 100
      Mbps downstream and 20 Mbps upstream are considered underserved.
    </p>
    <h4>Tips for using the map</h4>
    <ul>
      <li>Users may view the map and associated data by county, municipality, US Census Tract or US
        Census Block. The default view is by municipality, but Census Block boundaries offer the most
        granular view of the data. Additional details are available by selecting an area on the map.
      </li>
      <li>When zoomed in to a neighborhood (i.e. when street names become visible), points
        representing unserved and underserved homes and businesses will appear on the map. Any
        building without a point is considered to have access to broadband service from at least one, if
        not all, of the providers operating in that area.
      </li>
      <li>Map themes allow users to switch between broadband coverage and speed views. Speed
        information is based on the maximum download and upload speeds advertised for a given
        location.
      </li>
    </ul>
    <p>MBI is seeking the assistance of residents throughout the state to improve the accuracy of our
      broadband coverage maps. Please input your home address in to the search bar and check the status of
      your residence. If you feel that any of the information relative to the availability of broadband service at
      your residence is inaccurate, please complete and submit the form below. We appreciate your help and
      we will review and confirm the information that you provide below to inform updated versions of the
      coverage maps that will be released periodically by MBI. If any entity, such as a municipality, wishes to
      provide feedback for multiple locations please contact MBI at <a style={styles.link} href="mailto:mapfeedback@masstech.org" target="_blank" rel="noopener noreferrer">mapfeedback@masstech.org</a>.
    </p>
    <p>Please note the Federal Communications Commission (FCC) has also released the initial version of new
      broadband coverage maps that for the first time attempt to show the status of broadband availability at
      every address in the United States. You can access and review the FCC&apos;s new maps at:
      <a style={styles.link} href="https://broadbandmap.fcc.gov/home" target="_blank" rel="noopener noreferrer">https://broadbandmap.fcc.gov/home</a>.
      You can enter your address to review the information that the FCC has compiled. You will have the option
      to directly file a challenge with the FCC by clicking on <b>Location Challenge</b> or
      <b>Availability Challenge</b> and filling out the applicable online form.
    </p>
  </>
);

export default InfoContent;
